import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import StepForm from './StepForm';
import StepVisual from './StepVisual';
import StepHeader from './StepHeader';

import './Step.scss';
import { Link } from 'react-router-dom';
import Header from '../header';
import { RouteKeys } from '../route-keys';
import Footer from '../footer';

class Step extends Component {
  componentDidMount(): void {
    document.body.scrollIntoView({ behavior: 'smooth' });
  }
  render() {
    return (
      <>
        <Header />
        <div className="bg-[#efede7] py-14">
          <div className="container py-1">
            <div className="text-center">
              <h1 className="text-5xl text-center lg:text-[80px] text-primary pb-2 lg:pb-3.5">
                Register
              </h1>
              <p className="pb-6 mb-0.5 text-center text-black md:text-[22px]">
                Already have an account?
                <Link to={RouteKeys.Login}>
                  <a className="ml-1 text-tertiary">Login</a>
                </Link>
              </p>
            </div>
            <StepForm />
          </div>
        </div>
        <Footer />
      </>
    );
  } // end of render
}

// Step.propTypes = {};

// Step.defaultProps = {};

export default Step;
